import styled from 'styled-components'
import { colors, spacing } from '@chegg-ui/theme'
import { fanta } from '@chegg/fanta'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

const GRID_GAP_WIDTH = 16
const COLUMN_MAX_WIDTH = 565

export const H1 = styled.h1`
  color: ${colors.dark};
  ${AspiraStack};
  font-size: ${fanta.font.size.xxxl};
  font-weight: ${fanta.font.weight.heavy};
  line-height: ${fanta.spacing.xxxl};
  grid-row: 1/2;
  grid-column: 1/3;
  margin: ${fanta.spacing.lg} 0 ${fanta.spacing.md};
  @media (min-width: 900px) {
    margin: ${fanta.spacing.lg} 0 -7px;
  }
`
export const H2 = styled.h2`
  font-weight: ${fanta.font.weight.heavy};
  font-size: ${fanta.font.size.xl};
  margin-left: ${fanta.spacing.lg};
  margin-right: ${fanta.spacing.lg};
`

export const UploadWidgetH2 = styled.h2`
  font-weight: ${fanta.font.weight.heavy};
  font-size: ${fanta.font.size.xl};
  margin-top: 0;
`

export const Main = styled.main`
  padding: 0px ${spacing.px16} ${spacing.px24};
  margin-bottom: ${spacing.px40};
  button:focus {
    outline: 1px dotted #212121;
    outline: 5px auto -webkit-focus-ring-color;
  }

  > h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    font-family: ${(props) => props.theme.font.family};
  }
`

export const HeroBackground = styled.div`
  background-image: ${`url(${publicAssetUrl('dashboard-hero-bg.jpg')});`};
  background-repeat: no-repeat;
  background-color: #d0d0c6;
  background-position: left top;
  height: 122px;
  margin-bottom: ${fanta.spacing.xs};
  @media (max-width: 600px) {
    background-position: left top;
  }
`

export const HeroContainer = styled.div`
  max-width: 1200px;
  min-width: 320px;
  padding-left: ${fanta.spacing.md};
  padding-top: ${fanta.spacing.md};
  margin: auto;
`

export const HeroTitle = styled.h1`
  ${AspiraStack};
  font-size: ${fanta.font.size.xxxxl};
  font-weight: ${fanta.font.weight.heavy};
  line-height: 58px;
  color: ${colors.white};
  margin-top: 0px;
  margin-bottom: 0px;
`

export const HeroText = styled.div`
  ${AspiraStack};
  font-size: ${fanta.font.size.md};
  line-height: 22px;
  padding-top: ${fanta.spacing.xxs};
  color: ${colors.white};
`

export const PanelsContainer = styled.div`
  justify-content: center;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${GRID_GAP_WIDTH}px;
  margin: auto;
  @media (min-width: 900px) {
    grid-template-columns: 1fr 1fr;
    max-width: ${COLUMN_MAX_WIDTH * 2 + GRID_GAP_WIDTH}px;
  }
`
export const PanelContainer = styled.div`
  min-width: 0;
  &:last-child {
    margin-bottom: 0;
  }
  @media (min-width: 900px) {
    margin-bottom: 0px;
  }
  display: flex;
  flex-flow: column wrap;
  align-items: start;
  border: 2px solid ${colors.greyLight};
  box-sizing: border-box;
  background-color: ${colors.white};
  height: min-content;

  padding: 0;
`

export const CitationsPanelContainer = styled(PanelContainer)`
  grid-column: 1 / 3;
  grid-row: 2;
  width: 100%;

  @media (min-width: 900px) {
    grid-column: 1;
    grid-row: 2;
  }

  #citation-widget {
    padding: ${fanta.spacing.lg};
  }

  #create-citation-panel {
    padding: ${fanta.spacing.lg};
  }

  h2 {
    margin: 0 auto ${fanta.spacing.md} auto;
  }
`

export const CTAPanelContainer = styled(PanelContainer)`
  grid-column: 1 / 3;
  grid-row: 4;
  padding: ${fanta.spacing.lg} ${fanta.spacing.lg} 0 ${fanta.spacing.lg};
  @media (min-width: 900px) {
    grid-column: 1;
    grid-row: 3 / 4;
  }
  h2 {
    margin: 0 auto ${fanta.spacing.md} auto;
  }
`

export const WritingPanelContainer = styled(PanelContainer)`
  grid-column: 1 / 3;
  grid-row: 3;
  text-align: center;
  display: block;

  @media (min-width: 900px) {
    grid-column: 2;
    grid-row: 2 / 5;
  }
`

export const UploadWidgetContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${fanta.spacing.lg};

  #upload-widget-root {
    h3 {
      display: none;
    }
    h4 {
      display: none;
    }
  }

  small {
    margin: 0;
    padding-top: 16px;
    padding-bottom: 16px;
  }
`

export const UploadWidgetRoot = styled.div`
  display: flex;
  flex-grow: 2;
`

export const List = styled.ul`
  text-align: start;
  margin: 0;
`

export const ListContainer = styled.div<{ loadingContainer?: boolean }>`
  display: flex;
  flex-direction: column;
  background-color: ${colors.skyXlight};
  box-sizing: border-box;
  border-top: 2px solid ${colors.greyLight};
  width: 100%;
  justify-content: center;
  height: ${({ loadingContainer }) => (loadingContainer ? '324px' : 'auto')};
`
